import { IconArrowLeft } from "@tabler/icons-react";
import { format } from "date-fns";
import { useTranslations } from "next-intl";
import X from "@/assets/icons/x.svg";
import { Button } from "@/components/ui/button";
import { DialogClose } from "@/components/ui/dialog";
import { getLocaleForPathname } from "@/i18n/navigation";
import { getDateLocale } from "@/lib/helpers/diet-dates";

type DietMenuModalTopBarProps = {
  isScrolled: boolean;
  currentDate: Date;
  activeMealIngredients: string | null;
  setActiveMealIngredients?: (mealId: string | null) => void;
};

export const DietMenuModalTopBar = ({
  isScrolled,
  currentDate,
  activeMealIngredients,
  setActiveMealIngredients,
}: DietMenuModalTopBarProps) => {
  const t = useTranslations("diets");
  const locale = getLocaleForPathname();
  const dateLocale = getDateLocale(locale);

  if (activeMealIngredients) {
    return (
      <div className="fixed top-0 left-0 z-20 flex h-[60px] w-full items-center justify-start gap-2 border-b bg-brand-white px-4 py-4 md:px-8">
        <Button
          className="m-0 min-h-0 p-0"
          onClick={() => setActiveMealIngredients?.(null)}
          variant="ghost"
        >
          <IconArrowLeft className="size-6" strokeWidth={1.5} />
        </Button>
        <p className="max-md:-translate-x-1/2 font-medium text-xl max-md:absolute max-md:left-1/2 md:text-2xl">
          {activeMealIngredients}
        </p>
      </div>
    );
  }
  return (
    <div className="fixed top-0 left-0 z-20 flex h-[60px] w-full items-center justify-center border-b bg-brand-white p-4 md:hidden">
      <p className="font-medium text-xl">
        {isScrolled ? (
          <>
            <span className="capitalize">
              {format(currentDate, "EEEE", { locale: dateLocale })}
            </span>{" "}
            {format(currentDate, "d LLL", { locale: dateLocale })}
          </>
        ) : (
          t("menu")
        )}
      </p>
      <DialogClose className="-translate-y-1/2 absolute top-1/2 right-4 transform">
        <X />
      </DialogClose>
    </div>
  );
};
